// src/screens/booking/BookingScreen.js
// 80차: ProductCard에 체험형 공연(정원제, bookingFormat==='show') 배지 추가.
// 49차: 필터 버튼 완전 고정 + ActiveFilterTags가 searchRow 침범하지 않도록 레이아웃 분리
// 51차: 색 theme.js 단일화 — 색 자체 정의 제거, COLORS 참조
// 71차: filtered/cities/suggestions를 useMemo로 묶음 — 검색창 타이핑처럼 무관한
//       상태 변경에도 전체 상품 목록을 매번 다시 필터링/정렬하던 문제 해결
// 72차: BOOST 매장이 PICK 지정한 테마에 카드 배지("🌟 PICK") 노출 — StoreAdminScreen의
//       PICK 테마 등록에 productId가 저장되게 된 김에(72차) 테마조회 화면과 연결
// 72차: 매장 일시 휴업(isPaused) 카드에 "휴업중" 오버레이 + 예약 버튼 비활성화 추가
// 72차: 디자인 시스템 개편 — 2열 그리드 카드 → UNLOCK 디자인 목업의 리스트형 카드(썸네일
//       좌·정보 우)로 전면 교체, 이모지 아이콘 → Ionicons, 필터 적용 버튼을 GradientButton으로
// 74차: 데모 매장 노출 필터 롤백 → 재도입 — getAllProducts에 {uid, managedStoreIds} 전달.
//       데모 매장은 stores.visibleToUid와 일치하는 전용 데모 고객 계정, 또는 그 매장을
//       관리하는 매장관리자 본인(managedStoreIds)에게만 보임
// 74차: route.params.initialSearch 지원 — HomeScreen.js에 새로 생긴 검색 진입점에서
//       넘어온 검색어를 이 화면 진입 시 자동으로 반영
// 74차: 검색/필터 없는 기본 화면에서 PICK 테마를 상단에 노출(ListHeaderComponent) —
//       그 아래로 전체 테마 목록이 그대로 이어지도록 해서 비BOOST 매장도 계속 보이게 함
//       (PICK 전용으로 완전히 가리면 예약 탭에서 안 보이는 매장이 생기는 문제 방지)
// 74차: 필터 시트 "적용하기" 버튼이 안전영역 없이 화면 맨 아래에 딱 붙어있던 것을
//       useSafeAreaInsets 기반 하단 패딩으로 수정
// 74차: 필터/정렬 상태가 다른 탭으로 이동해도 안 풀리던 문제 — Tab.Navigator 자체의
//       'state' 이벤트를 구독해 Booking 탭을 벗어나면 resetFilters() 호출
// 75차: 장르 배지가 장르와 무관하게 항상 블루(추리 색상) 하나로 고정 표시되던 것을
//       GENRE_META 기반 장르별 색상 + 영문 병기로 수정. 난이도 도트 색도 goldLight로 정합.
// 75차: "별점순" 정렬 라벨과 검색행의 "필터" 아이콘 버튼이 둘 다 setShowFilter(true)만
//       호출하는 완전히 동일한 동작이었음(같은 시트를 여는 중복 버튼) — 필터 아이콘(활성
//       필터 개수 배지 포함)만 남기고 정렬 라벨은 제거.

import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
  View, Text, FlatList, TouchableOpacity, StyleSheet,
  TextInput, RefreshControl,
  ScrollView, Modal, Dimensions, Animated, Pressable,
} from 'react-native';
// 78차 37차: 테마 썸네일 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import { useRoute, useFocusEffect } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
  collection, query, where, getDocs,
  addDoc, deleteDoc, doc, serverTimestamp,
} from 'firebase/firestore';
import { db } from '../../services/firebase';
import { getAllProducts, normalizeProduct } from '../../services/productService';
import { isConfirmedMinorBirth } from '../../utils/dateUtils';
import { getActivePickStoreEvents } from '../../services/eventService';
import { useAuth } from '../../contexts/AuthContext';
import AppHeader from '../../components/common/AppHeader';
import LoadingOverlay from '../../components/common/LoadingOverlay';
import { COLORS, RADIUS, FONTS } from '../../constants/theme';
import { getGenreMeta, GENRES, splitGenres, getDifficultyLabel, getSeatingTypeLabel } from '../../constants';
import { Ionicons } from '@expo/vector-icons';
import GradientButton from '../../components/common/GradientButton';
import { TextButton } from '../../components/common/Buttons';
import { MenuStoreIcon, SearchIcon, MenuPointsIcon, PeopleIcon, LocationIcon, IconLabel, SpotlightStarIcon, ContribRatingIcon, MenuReviewIcon, TrendingUpIcon, PriceIcon, DifficultyLockIcon, DifficultyGaugeDots, MenuFavoriteIcon, GenreIcon, HalloweenBadgeIcon, CancelIcon, TrophyIcon, StatsIcon, DifficultyTargetIcon, EmptyStoresIcon } from '../../components/common/Icons';
import { showAlert } from '../../components/common/AppAlert';
import { LogoMark } from '../../components/common/AppHeader';

const { height } = Dimensions.get('window');
const GOLD = COLORS.gold, BG = COLORS.bg, SURFACE = COLORS.surface, SURFACE2 = COLORS.surface2;
const BORDER = COLORS.border, TEXT = COLORS.text;
const TEXT_MUTED = COLORS.textMuted;
const ORANGE = COLORS.orange, RED = COLORS.red;
const ON_GOLD = COLORS.onGold;

// 78차 45차: 이 화면 전용 목록이 constants/index.js의 GENRES와 어긋나(미스터리/드라마/
// 감성 누락) 있어 마스터 목록 참조로 교체 — SuperAdminStoresScreen.js와 동일한 수정
const GENRE_OPTIONS = GENRES;
// 78차 39차: 필터 이모지(🔓🔒🔐⛓️) → 이번 세션에 만든 DifficultyLockIcon(자물쇠, 4단계 전부
// 동일 모양)+DifficultyGaugeDots(채움 도트) 조합 재사용 — ThemeDetailScreen의 난이도 표기와
// 톤 통일. 라벨 자체도 StoreDetailScreen.js/ThemeDetailScreen.js와 각자 중복 정의돼 있던 것을
// constants/index.js의 getDifficultyLabel로 공용화(전수조사로 발견).
const DIFFICULTY_OPTIONS = ['easy', 'normal', 'hard', 'expert'].map(value => ({ value, label: getDifficultyLabel(value) }));
// 80차 후속: 체험형(정원제) 테마는 1인 관람도 흔해 '1인' 옵션 추가(방탈출은 통상 2인부터라 영향 없음)
const PEOPLE_OPTIONS = ['1인','2인','3인','4인','5인','6인+'];
// 78차 39차: 정렬 이모지(⭐💬✨💰) → 기존 아이콘 재사용(ContribRatingIcon/MenuReviewIcon/
// TrendingUpIcon/PriceIcon), 새 디자인 자산 불필요.
const SORT_OPTIONS = [
  { value: 'rating',    label: '별점순',   Icon: ContribRatingIcon },
  { value: 'review',    label: '리뷰순',   Icon: MenuReviewIcon },
  { value: 'newest',    label: '최신순',   Icon: TrendingUpIcon },
  { value: 'price_asc', label: '낮은가격', Icon: PriceIcon },
];

// 75차: 난이도 표시를 별(★)에서 원형 마커(●/○)로 변경
// 78차 31차: 즐겨찾기 하트 버튼에 accessibilityLabel 추가 — Maestro iOS 시뮬레이터
// 검증 중 이 버튼이 접근성 라벨 없는 아이콘 전용이라 좌표 추정으로만 탭할 수 있었고,
// 카드 터치 영역과 겹쳐 잘못된 카드를 열어버리는 문제가 반복돼 근본 수정.
// 78차 32차: 같은 이유로 검색어 지우기(close-circle)/필터(options-outline) 아이콘
// 버튼에도 accessibilityLabel 추가(접근성 라벨 전수 점검).
// 78차 63차: 이 카드용 로컬 5단계(easy~expert:1~5, 3 누락) 도트가 같은 화면의 필터
// 칩(352줄)이 쓰는 올바른 4단계 DifficultyGaugeDots와 어긋나 있었음 — 통일.
const StarRow = ({ difficulty, size = 11 }) => (
  <DifficultyGaugeDots difficulty={difficulty} size={size} gap={3} color={COLORS.goldLight} mutedColor="#333" />
);

const HighlightText = ({ text, keyword, style, numberOfLines }) => {
  if (!keyword || !text) return <Text style={style} numberOfLines={numberOfLines}>{text}</Text>;
  const lower = text.toLowerCase(), kw = keyword.toLowerCase(), idx = lower.indexOf(kw);
  if (idx === -1) return <Text style={style} numberOfLines={numberOfLines}>{text}</Text>;
  return (
    <Text style={style} numberOfLines={numberOfLines}>
      {text.slice(0, idx)}
      <Text style={{ color: GOLD, fontWeight: '900', backgroundColor: GOLD+'20' }}>
        {text.slice(idx, idx + keyword.length)}
      </Text>
      {text.slice(idx + keyword.length)}
    </Text>
  );
};

function useFavorites(userId) {
  const [favMap, setFavMap] = useState({});
  const load = useCallback(async () => {
    if (!userId) { setFavMap({}); return; }
    try {
      const snap = await getDocs(query(collection(db, 'favorites'), where('uid', '==', userId)));
      const map = {};
      snap.docs.forEach(d => { map[d.data().productId] = d.id; });
      setFavMap(map);
    } catch { setFavMap({}); }
  }, [userId]);
  useEffect(() => { load(); }, [load]);
  const toggle = useCallback(async (productId) => {
    if (!userId) return;
    const existing = favMap[productId];
    if (existing) {
      setFavMap(prev => { const n = { ...prev }; delete n[productId]; return n; });
      try { await deleteDoc(doc(db, 'favorites', existing)); } catch { load(); }
    } else {
      setFavMap(prev => ({ ...prev, [productId]: '__temp__' }));
      try {
        // 78차 35차: 즐겨찾기 등록 시 "소식 알림"이 기본 OFF라 대부분 다시 켜야 하는게
        // 불편하다는 신고 — 신규 등록 시점부터 기본 ON으로 저장(FavoritesScreen.js에서
        // 기존 즐겨찾기의 `notify ?? false` 폴백은 과거 데이터 호환용으로 그대로 둠).
        const ref = await addDoc(collection(db, 'favorites'), { uid: userId, productId, notify: true, createdAt: serverTimestamp() });
        setFavMap(prev => ({ ...prev, [productId]: ref.id }));
      } catch { load(); }
    }
  }, [userId, favMap, load]);
  return { favMap, toggle };
}

// 72차: UNLOCK 디자인 목업의 "테마 카드"를 그대로 반영 — 2열 그리드(이미지 위/정보 아래)를
// 썸네일-좌 · 정보-우 리스트형 카드로 전면 교체. 목업엔 카드 안에 예약 버튼이 없었음 —
// 카드를 누르면 상세로 이동해 거기서 GradientButton으로 예약하므로 자연스럽게 맞음.
const ProductCard = ({ item, onPress, isFav, onFavToggle, isSoldOut, searchKeyword, isPick }) => {
  const p = normalizeProduct(item);
  const isShow = p.bookingFormat === 'show';
  const minPrice = p.pricing?.length > 0 ? Math.min(...p.pricing.map(pr => Number(pr.price)||0)) : p.price;
  const isPaused = p.isPaused === true;
  const blocked = isSoldOut || isPaused;
  return (
    <TouchableOpacity style={card.wrap} onPress={() => !blocked && onPress(p)} activeOpacity={0.85} disabled={blocked}>
      <View style={card.thumbWrap}>
        {p.thumbnailUrl ? <Image source={{ uri: p.thumbnailUrl }} style={card.thumb} />
          : <View style={[card.thumb, card.placeholder]}><LogoMark size={22} /></View>}
        {blocked && (
          <View style={card.blockedOverlay}>
            <Text style={card.blockedText}>{isSoldOut ? '마감' : '휴업중'}</Text>
          </View>
        )}
      </View>

      <View style={card.info}>
        <View style={card.titleRow}>
          <HighlightText text={p.name} keyword={searchKeyword} style={card.title} numberOfLines={1} />
          <View style={{ flex:1 }} />
          {/* 80차 후속: [레이아웃 수정] 위치를 하단 배지 행에서 제목 행으로 옮기고,
              즐겨찾기(하트)도 이 행으로 옮겨 위치·가격 모두 하트의 우측 여백을
              기준으로 정렬(사용자 스크린샷 피드백). */}
          {(item.city||item.district) && (
            <Text style={card.location} numberOfLines={1}>
              {[item.city,item.district].filter(Boolean).join(' ')}
            </Text>
          )}
          <TouchableOpacity style={card.favBtn} onPress={() => onFavToggle(p.id)} activeOpacity={0.8} hitSlop={{top:8,bottom:8,left:8,right:8}}
            accessibilityLabel={isFav ? '즐겨찾기 해제' : '즐겨찾기 추가'}>
            <Ionicons name={isFav ? 'heart' : 'heart-outline'} size={18} color={isFav ? '#ff5f8f' : TEXT_MUTED} />
          </TouchableOpacity>
        </View>
        <Text style={card.store} numberOfLines={1}>
          {p.storeName}{p.branchName ? ` · ${p.branchName}` : ''}
        </Text>
        {/* 80차 후속: 체험형 공연은 탈출 난이도 개념이 없어 표시하지 않음 */}
        {!isShow && (
          <View style={card.metaRow}>
            {item.difficulty && <StarRow difficulty={item.difficulty} size={10} />}
            <View style={card.ratingWrap}>
              <Ionicons name="star" size={11} color={GOLD} />
              <Text style={card.ratingTxt}>{Number(item.rating||0).toFixed(1)}</Text>
              <Text style={card.reviewCountTxt}>({item.reviewCount||0})</Text>
            </View>
          </View>
        )}
        <View style={card.badgeRow}>
          {/* 80차 후속: [버그 수정, 실기기 신고] PICK/기간한정 배지가 titleRow(제목+위치+
              하트가 이미 경쟁 중인 줄)에 같이 있어서, 그 두 배지가 뜨는 카드만 제목이
              유독 짧게 잘렸음 — badgeRow(flexWrap이라 여유 있음)로 이동, 항상 맨 앞에. */}
          {isPick && !blocked && (
            <View style={card.pickBadge}><IconLabel Icon={SpotlightStarIcon} size={11} color={card.pickBadgeText.color || GOLD} textStyle={card.pickBadgeText}>PICK</IconLabel></View>
          )}
          {item.isTemporary && !blocked && !isPick && (
            <View style={card.tempBadge}><Text style={card.tempText}>기간한정</Text></View>
          )}
          {/* 80차 후속: [정책 확정] 모든 테마카드 배지 순서 — ①형식(방탈출/체험형, 필수)
              → ②19금(해당 시) → ③장르. 형식 배지는 이제 방탈출도 항상 뜨도록(이전엔
              체험형만 떴음) 대칭으로 추가. */}
          {isShow ? (
            <View style={card.showBadge}><Text style={card.showText}>체험형</Text></View>
          ) : (
            <View style={card.roomBadge}><Text style={card.roomText}>방탈출</Text></View>
          )}
          {/* 80차 후속: 체험형 전용 — 단독 대관/합석 뱃지(방탈출은 구조상 항상 단독이라 불필요) */}
          {isShow && (
            <View style={card.seatBadge}><Text style={card.seatText}>{getSeatingTypeLabel(p.seatingType)}</Text></View>
          )}
          {item.isAdultOnly && (
            <View style={card.adultBadge}><Text style={card.adultText}>19금</Text></View>
          )}
          {item.genre && (() => {
            const gm = getGenreMeta(item.genre);
            return (
              <View style={[card.genreChip, { backgroundColor: gm.color+'26', borderColor: gm.color+'59' }]}>
                <Text style={[card.genreChipText, { color: gm.color }]}>
                  {item.genre}{gm.en ? ` · ${gm.en}` : ''}
                </Text>
              </View>
            );
          })()}
        </View>
        {/* 80차 후속: [버그 수정, 실기기 발견] 가격을 배지와 한 줄에 두고 flexWrap으로만
            방어하면, 배지 개수·가격 문구 길이 조합에 따라 어떨 땐 같은 줄에 어떨 땐
            다음 줄에 붙는 등 카드마다 들쭉날쭉해 보였음 — 배지 줄과 가격 줄을 아예
            분리해 항상 독립된 한 줄로, 오른쪽 정렬로 고정(어떤 배지 조합·가격 길이가
            와도 화면 밖으로 삐져나올 수 없음). */}
        <View style={card.priceRow}>
          {isShow ? (
            p.pricePerPerson > 0 && <Text style={card.price}>{Number(p.pricePerPerson).toLocaleString()}원 (1인당)</Text>
          ) : (
            minPrice!=null && minPrice>0 && <Text style={card.price}>{Number(minPrice).toLocaleString()}원~</Text>
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
};
const card = StyleSheet.create({
  // 80차 후속: [버그 수정] alignItems:'center'였을 때, info(제목+가게명+배지+가격 5줄)가
  // thumbWrap(88px 고정)보다 키가 커서 썸네일만 세로 중앙으로 내려앉고 제목은 카드
  // 맨 위에 그대로 남아 "제목이 사진보다 위에 떠 보이는" 어긋남이 있었음 — flex-start로
  // 바꿔 둘 다 위쪽 기준으로 나란히 시작(제목이 사진과 같은 높이에서 시작).
  wrap:              { flexDirection:'row', gap:14, backgroundColor:SURFACE, borderRadius:RADIUS.lg,
                       borderWidth:1, borderColor:BORDER, padding:12, marginBottom:12, alignItems:'flex-start' },
  thumbWrap:         { width:88, height:88, borderRadius:RADIUS.md, overflow:'hidden', position:'relative', flexShrink:0 },
  thumb:             { width:'100%', height:'100%', backgroundColor:SURFACE2 },
  placeholder:       { justifyContent:'center', alignItems:'center' },
  blockedOverlay:    { ...StyleSheet.absoluteFillObject, backgroundColor:'rgba(0,0,0,0.65)', justifyContent:'center', alignItems:'center' },
  blockedText:       { color:'#fff', fontSize:11, fontWeight:'900', letterSpacing:1 },
  info:              { flex:1, gap:5, minWidth:0 },
  titleRow:          { flexDirection:'row', alignItems:'center', gap:6 },
  title:             { color:TEXT, fontSize:15, fontFamily:FONTS.bodyBold, flexShrink:1 },
  store:             { color:TEXT_MUTED, fontSize:12, fontFamily:FONTS.body },
  metaRow:           { flexDirection:'row', alignItems:'center', gap:10 },
  ratingWrap:        { flexDirection:'row', alignItems:'center', gap:3 },
  ratingTxt:         { color:TEXT, fontSize:12, fontFamily:FONTS.bodySemiBold },
  reviewCountTxt:    { color:TEXT_MUTED, fontSize:11 },
  // 80차 후속: 배지 줄(badgeRow)과 가격 줄(priceRow)을 분리 — 배지는 개수만큼 자유롭게
  // 줄바꿈(flexWrap), 가격은 항상 그 아래 독립된 줄에서 오른쪽 정렬로 고정.
  badgeRow:          { flexDirection:'row', alignItems:'center', gap:8, flexWrap:'wrap', rowGap:6 },
  priceRow:          { flexDirection:'row', justifyContent:'flex-end' },
  // 72차: BOOST 매장 PICK 테마 배지 — EventsScreen의 PICK 브랜딩(GOLD)과 톤 통일
  pickBadge:         { backgroundColor:GOLD, borderRadius:RADIUS.sm, paddingHorizontal:6, paddingVertical:2 },
  pickBadgeText:     { color:ON_GOLD, fontSize:9, fontWeight:'800' },
  tempBadge:         { backgroundColor:ORANGE+'22', borderWidth:1, borderColor:ORANGE+'50', borderRadius:RADIUS.sm, paddingHorizontal:6, paddingVertical:2 },
  // 80차: 체험형 공연(정원제) 배지
  // 80차 후속: 장르 칩(genreChip)과 패딩/폰트가 미묘하게 달라("체험형"/"합석"만 유독 작고
  // 굵어 보인다는 신고) 크기를 통일 — 색만 다르게.
  showBadge:         { backgroundColor:COLORS.blue+'22', borderWidth:1, borderColor:COLORS.blue+'50', borderRadius:RADIUS.sm, paddingHorizontal:8, paddingVertical:2 },
  showText:          { color:COLORS.blue, fontSize:10, fontWeight:'700' },
  roomBadge:         { backgroundColor:COLORS.teal+'22', borderWidth:1, borderColor:COLORS.teal+'50', borderRadius:RADIUS.sm, paddingHorizontal:8, paddingVertical:2 },
  roomText:          { color:COLORS.teal, fontSize:10, fontWeight:'700' },
  adultBadge:        { backgroundColor:COLORS.dangerBg, borderWidth:1, borderColor:COLORS.danger+'50', borderRadius:RADIUS.sm, paddingHorizontal:8, paddingVertical:2 },
  adultText:         { color:COLORS.danger, fontSize:10, fontWeight:'700' },
  seatBadge:         { backgroundColor:COLORS.purple+'22', borderWidth:1, borderColor:COLORS.purple+'50', borderRadius:RADIUS.sm, paddingHorizontal:8, paddingVertical:2 },
  seatText:          { color:COLORS.purple, fontSize:10, fontWeight:'700' },
  tempText:          { color:ORANGE, fontSize:9, fontWeight:'700' },
  genreChip:         { borderRadius:RADIUS.sm, borderWidth:1, paddingHorizontal:8, paddingVertical:2 },
  genreChipText:     { fontSize:10, fontWeight:'700' },
  location:          { color:TEXT_MUTED, fontSize:11, flexShrink:1 },
  price:             { color:GOLD, fontSize:13, fontFamily:FONTS.bodyBold },
  favBtn:            { width:32, height:32, borderRadius:16, alignItems:'center', justifyContent:'center', flexShrink:0 },
});

// 78차 39차: Icon/extra prop 추가 — DIFFICULTY_OPTIONS/SORT_OPTIONS의 기본 이모지
// (🔓🔒🔐⛓️⭐💬✨💰)를 실제 아이콘으로 교체하기 위함. 기존 호출부는 안 넘기면 그대로 동작.
const Chip = ({ label, active, onPress, seasonal, color, Icon, extra }) => (
  <TouchableOpacity
    style={[ch.chip, active&&ch.active, seasonal&&ch.seasonal, seasonal&&active&&ch.seasonalActive, color&&active&&{ borderColor:color, backgroundColor:color+'20' }, Icon && { flexDirection:'row', alignItems:'center', gap:5 }]}
    onPress={onPress}>
    {Icon && <Icon size={13} color={active ? (color || GOLD) : TEXT_MUTED} />}
    <Text style={[ch.text, active&&ch.activeText, seasonal&&ch.seasonalText, color&&active&&{ color }]}>{label}</Text>
    {extra}
  </TouchableOpacity>
);
const ch = StyleSheet.create({
  chip:          { paddingHorizontal:13, paddingVertical:7, borderRadius:RADIUS.pill, borderWidth:1, borderColor:BORDER },
  active:        { borderColor:GOLD, backgroundColor:GOLD+'20' },
  seasonal:      { borderColor:'rgba(255,107,53,0.35)' },
  seasonalActive:{ backgroundColor:'rgba(255,107,53,0.15)', borderColor:ORANGE },
  text:          { color:TEXT_MUTED, fontSize:12, fontFamily:FONTS.body },
  activeText:    { color:GOLD, fontWeight:'700' },
  seasonalText:  { color:ORANGE },
});

// 49차: ActiveFilterTags — 항상 searchRow 아래 별도 행으로 렌더
const ActiveFilterTags = ({ genres, city, selectedFormat, onlyFav, difficulties, peopleFilter,
  onRemoveGenre, onRemoveCity, onRemoveFormat, onRemoveFav, onRemoveDifficulty, onRemovePeople }) => {
  const tags = [
    ...(onlyFav  ? [{ key:'fav',    label:'즐겨찾기', Icon:MenuFavoriteIcon, onRemove:onRemoveFav }] : []),
    ...genres.map(g => ({ key:g, label:g, Icon:GenreIcon, onRemove:()=>onRemoveGenre(g) })),
    // 78차 39차: 이모지별 라벨 4종 하드코딩 대신 getDifficultyLabel 재사용 — 78차37차에
    // 이미 확정된 "자물쇠 아이콘은 4단계 전부 동일 모양"과 같은 이유로 이모지도 통일.
    ...difficulties.map(d => ({
      key:d,
      label:getDifficultyLabel(d),
      Icon:DifficultyLockIcon,
      onRemove:()=>onRemoveDifficulty(d),
    })),
    ...(city        ? [{ key:'city',   label:city,        Icon:LocationIcon, onRemove:onRemoveCity }]   : []),
    ...(peopleFilter? [{ key:'people', label:peopleFilter, Icon:PeopleIcon,   onRemove:onRemovePeople }]: []),
    // 80차 후속: "특별 운영"의 기간한정 필터를 방탈출/체험형 형식 필터로 교체
    ...(selectedFormat ? [{ key:'format', label:selectedFormat==='show'?'체험형':'방탈출', Icon:HalloweenBadgeIcon, onRemove:onRemoveFormat, seasonal:true }] : []),
  ];
  if (!tags.length) return null;
  return (
    <View style={af.wrap}>
      <ScrollView horizontal showsHorizontalScrollIndicator={false}
        contentContainerStyle={af.scroll}>
        {tags.map(t => (
          <TouchableOpacity key={t.key}
            style={[af.tag, t.seasonal && af.tagSeasonal]}
            onPress={t.onRemove}>
            {t.Icon && <t.Icon size={11} color={t.seasonal ? ORANGE : GOLD} />}
            <Text style={[af.tagText, t.seasonal && { color:ORANGE }]}>{t.label}</Text>
            <Text style={[af.tagX, t.seasonal && { color:ORANGE }]}>×</Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </View>
  );
};
const af = StyleSheet.create({
  wrap:        { backgroundColor:BG },
  scroll:      { paddingHorizontal:16, paddingVertical:8, gap:8, flexDirection:'row' },
  tag:         { flexDirection:'row', alignItems:'center', backgroundColor:GOLD+'18', borderRadius:16, paddingHorizontal:12, paddingVertical:5, borderWidth:1, borderColor:GOLD+'60', gap:4 },
  tagSeasonal: { borderColor:ORANGE, backgroundColor:'rgba(255,107,53,0.12)' },
  tagText:     { color:GOLD, fontSize:12, fontWeight:'600' },
  tagX:        { color:GOLD, fontSize:14, fontWeight:'700' },
});

const FilterBottomSheet = ({
  visible, cities, selectedGenres, selectedCity, selectedFormat, onlyFav,
  selectedDifficulties, peopleFilter, sortBy, loggedIn,
  onToggleGenre, onSelectCity, onSelectFormat, onToggleFav,
  onToggleDifficulty, onSelectPeople, onSelectSort, onReset, onClose,
}) => {
  const slideAnim = useRef(new Animated.Value(height)).current;
  const insets = useSafeAreaInsets();
  useEffect(() => {
    if (visible) Animated.spring(slideAnim, { toValue:0, useNativeDriver:true, tension:60, friction:11 }).start();
    else Animated.timing(slideAnim, { toValue:height, duration:250, useNativeDriver:true }).start();
  }, [visible]);
  const activeCount = selectedGenres.length + selectedDifficulties.length +
    (selectedCity?1:0) + (selectedFormat?1:0) + (onlyFav?1:0) + (peopleFilter?1:0) + (sortBy!=='rating'?1:0);
  return (
    <Modal visible={visible} transparent animationType="none" onRequestClose={onClose}>
      <Pressable style={bs.dim} onPress={onClose} />
      <Animated.View style={[bs.sheet, { transform:[{ translateY:slideAnim }] }]}>
        <View style={bs.handle} />
        <View style={bs.header}>
          <Text style={bs.title}>필터 & 정렬</Text>
          <View style={{ flexDirection:'row', gap:12 }}>
            {activeCount>0 && <TextButton label={`초기화 (${activeCount})`} onPress={onReset} textStyle={bs.resetBtn} />}
            <TouchableOpacity onPress={onClose} accessibilityLabel="닫기"><CancelIcon size={16} color={bs.closeBtn.color || TEXT_MUTED} /></TouchableOpacity>
          </View>
        </View>
        <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ paddingBottom:32 }}>
          <IconLabel Icon={StatsIcon} size={12} color={bs.sectionLabel.color || TEXT_MUTED} textStyle={bs.sectionLabel}>정렬</IconLabel>
          <View style={bs.chipRow}>{SORT_OPTIONS.map(opt => <Chip key={opt.value} label={opt.label} Icon={opt.Icon} active={sortBy===opt.value} onPress={()=>onSelectSort(opt.value)} />)}</View>
          {loggedIn && <><IconLabel Icon={MenuFavoriteIcon} size={12} color={bs.sectionLabel.color || TEXT_MUTED} textStyle={bs.sectionLabel}>즐겨찾기</IconLabel>
            <View style={bs.chipRow}>
              <Chip label="전체" active={!onlyFav} onPress={()=>onToggleFav(false)} />
              <Chip label="즐겨찾기만" active={onlyFav} onPress={()=>onToggleFav(true)} />
            </View></>}
          <IconLabel Icon={DifficultyTargetIcon} size={12} color={bs.sectionLabel.color || TEXT_MUTED} textStyle={bs.sectionLabel}>난이도</IconLabel>
          <View style={bs.chipRow}>{DIFFICULTY_OPTIONS.map(opt => {
            const active = selectedDifficulties.includes(opt.value);
            const tintColor = opt.value==='expert'?RED:opt.value==='hard'?ORANGE:undefined;
            return (
              <Chip key={opt.value} label={opt.label} Icon={DifficultyLockIcon} active={active} onPress={()=>onToggleDifficulty(opt.value)} color={tintColor}
                extra={<DifficultyGaugeDots difficulty={opt.value} size={4} gap={2} color={active ? (tintColor || GOLD) : TEXT_MUTED} mutedColor={BORDER} />} />
            );
          })}</View>
          <IconLabel Icon={PeopleIcon} size={10} color={TEXT_MUTED} textStyle={bs.sectionLabel}>인원</IconLabel>
          <View style={bs.chipRow}>
            <Chip label="전체" active={!peopleFilter} onPress={()=>onSelectPeople(null)} />
            {PEOPLE_OPTIONS.map(p => <Chip key={p} label={p} active={peopleFilter===p} onPress={()=>onSelectPeople(peopleFilter===p?null:p)} />)}
          </View>
          {/* 80차 후속: 기간한정 필터를 방탈출/체험형 형식 필터로 교체(기간한정 배지 자체는 카드에 그대로 유지) */}
          <IconLabel Icon={HalloweenBadgeIcon} size={12} color={bs.sectionLabel.color || TEXT_MUTED} textStyle={bs.sectionLabel}>특별 운영</IconLabel>
          <View style={bs.chipRow}>
            <Chip label="전체" active={!selectedFormat} onPress={()=>onSelectFormat(null)} />
            <Chip label="방탈출" active={selectedFormat==='room'} onPress={()=>onSelectFormat(selectedFormat==='room'?null:'room')} />
            <Chip label="체험형" active={selectedFormat==='show'} onPress={()=>onSelectFormat(selectedFormat==='show'?null:'show')} seasonal />
          </View>
          {cities.length>0 && <><IconLabel Icon={LocationIcon} size={10} color={TEXT_MUTED} textStyle={bs.sectionLabel}>지역</IconLabel>
            <View style={bs.chipRow}>
              <Chip label="전체" active={!selectedCity} onPress={()=>onSelectCity(null)} />
              {cities.map(c => <Chip key={c} label={c} active={selectedCity===c} onPress={()=>onSelectCity(selectedCity===c?null:c)} />)}
            </View></>}
          <IconLabel Icon={GenreIcon} size={12} color={bs.sectionLabel.color || TEXT_MUTED} textStyle={bs.sectionLabel}>장르</IconLabel>
          <View style={bs.chipRow}>{GENRE_OPTIONS.map(g => <Chip key={g} label={g} active={selectedGenres.includes(g)} onPress={()=>onToggleGenre(g)} />)}</View>
        </ScrollView>
        <View style={{ paddingTop: 8, paddingBottom: Math.max(insets.bottom, 16) }}>
          <GradientButton
            label={`적용하기${activeCount>0?` (${activeCount})`:''}`}
            onPress={onClose}
          />
        </View>
      </Animated.View>
    </Modal>
  );
};
const bs = StyleSheet.create({
  dim:          { ...StyleSheet.absoluteFillObject, backgroundColor:'rgba(0,0,0,0.6)' },
  sheet:        { position:'absolute', bottom:0, left:0, right:0, backgroundColor:SURFACE, borderTopLeftRadius:RADIUS.lg, borderTopRightRadius:RADIUS.lg, paddingHorizontal:20, paddingTop:12, maxHeight:height*0.85, borderWidth:1, borderColor:BORDER, borderBottomWidth:0 },
  handle:       { alignSelf:'center', width:36, height:4, backgroundColor:'rgba(255,255,255,0.15)', borderRadius:2, marginBottom:16 },
  header:       { flexDirection:'row', justifyContent:'space-between', alignItems:'center', marginBottom:20 },
  title:        { color:TEXT, fontSize:16, fontWeight:'800' },
  resetBtn:     { color:RED, fontSize:13, fontWeight:'600' },
  closeBtn:     { color:TEXT_MUTED, fontSize:18 },
  sectionLabel: { color:TEXT_MUTED, fontSize:10, fontWeight:'700', letterSpacing:1, textTransform:'uppercase', marginBottom:10, marginTop:16 },
  chipRow:      { flexDirection:'row', flexWrap:'wrap', gap:8 },
  // 72차: 적용하기 버튼은 GradientButton 컴포넌트로 교체 — 위 2개 스타일은 삭제됨
});

export default function BookingScreen({ navigation }) {
  const route = useRoute();
  const { isLoggedIn, user, profile } = useAuth();
  const isStoreAdmin = profile?.adminRole === 'store';
  const managedStores = profile?.managedStores || [];
  const [products, setProducts]     = useState([]);
  // 72차: BOOST 매장이 PICK으로 지정한 테마의 productId 집합 — 테마조회 카드에 배지 표시용
  const [pickProductIds, setPickProductIds] = useState(new Set());
  const [loading, setLoading]       = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [inputValue, setInputValue]           = useState('');
  const [searchKeyword, setSearchKeyword]     = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [recentSearches, setRecentSearches]   = useState([]);
  const [showFilter, setShowFilter]                     = useState(false);
  const [selectedGenres, setSelectedGenres]             = useState([]);
  const [selectedDifficulties, setSelectedDifficulties] = useState([]);
  const [selectedCity, setSelectedCity]                 = useState(null);
  const [peopleFilter, setPeopleFilter]                 = useState(null);
  // 80차 후속: "특별 운영" 기간한정 필터 → 방탈출/체험형 형식 필터로 교체(null='전체')
  const [selectedFormat, setSelectedFormat]             = useState(null);
  const [onlyFav, setOnlyFav]                           = useState(false);
  const [sortBy, setSortBy]                             = useState('rating');
  const { favMap, toggle: toggleFav } = useFavorites(user?.uid);
  // 79차: 탭을 빠르게 오가면 이전 포커스의 load()가 늦게 응답해 최신 목록을 오래된
  // 것으로 덮어쓸 수 있었음(MyReviewsScreen.js가 74차에 막아둔 것과 동일 위험) —
  // activeRef로 이전 포커스 세션의 setState만 무시.
  const activeRef = useRef(true);

  const load = useCallback(async () => {
    try {
      // 80차 후속: 확인된 미성년자에게 19금 테마 목록 노출 차단(isVisibleToViewer 참고)
      const isMinor = isConfirmedMinorBirth(profile?.birth);
      const [all, boostEvents] = await Promise.all([
        getAllProducts({ uid: user?.uid, managedStoreIds: managedStores, isMinor }),
        getActivePickStoreEvents(),
      ]);
      if (!activeRef.current) return;
      let list = Array.isArray(all) ? all : [];
      if (isStoreAdmin && managedStores.length > 0)
        list = list.filter(p => p.storeId && managedStores.includes(p.storeId));
      setProducts(list);
      setPickProductIds(new Set(boostEvents.map(e => e.productId).filter(Boolean)));
    } catch { if (activeRef.current) setProducts([]); }
    finally { if (activeRef.current) { setLoading(false); setRefreshing(false); } }
  }, [isStoreAdmin, managedStores.join(','), user?.uid, profile?.birth]);
  // 78차 38차: 매장관리자가 PICK 테마를 등록한 직후 같은 세션에서 하단 탭으로 "테마조회"에
  // 들어가도 반영이 안 된다는 신고 — 이 화면이 마운트 1회성 useEffect로만 데이터를 불러오고
  // 있어서, 탭 전환(포커스만 바뀜, 리마운트 아님)으로는 재조회가 안 됐던 것이 원인
  // (MyReviewsScreen.js가 74차에 동일한 이유로 이미 겪었던 문제와 같은 패턴).
  useFocusEffect(useCallback(() => {
    activeRef.current = true;
    load();
    return () => { activeRef.current = false; };
  }, [load]));

  // 71차: products.filter().sort() 체인이 검색창 타이핑(inputValue)처럼 무관한
  // 상태 변경에도 매번 재실행되던 것을 useMemo로 묶어 실제 의존값이 바뀔 때만 재계산되도록 수정
  const cities = useMemo(() =>
    [...new Set(products.map(p => p.city).filter(Boolean))].sort(),
    [products]
  );
  const getMinPrice = p => { const pr=p.pricing||[]; return pr.length>0?Math.min(...pr.map(x=>Number(x.price)||0)):Number(p.price)||0; };
  const getPMin = p => { const pr=p.pricing||[]; return pr.length>0?Math.min(...pr.map(x=>Number(x.people)||2)):Number(p.minPeople)||2; };
  const getPMax = p => { const pr=p.pricing||[]; return pr.length>0?Math.max(...pr.map(x=>Number(x.people)||2)):Number(p.maxPeople)||getPMin(p); };

  const filtered = useMemo(() => products.filter(p => {
    const norm=normalizeProduct(p), kw=searchKeyword.toLowerCase();
    if (kw && !norm.name?.toLowerCase().includes(kw) && !norm.storeName?.toLowerCase().includes(kw)
      && !p.genre?.toLowerCase().includes(kw) && !p.city?.toLowerCase().includes(kw)
      && !p.district?.toLowerCase().includes(kw)) return false;
    if (selectedCity && p.city!==selectedCity) return false;
    // 78차 45차: genre가 "공포/추리"처럼 2개 이어붙은 값일 수 있어 정확히 일치가 아니라
    // 포함된 장르 중 하나라도 필터에 걸리면 통과하도록 수정
    if (selectedGenres.length && !splitGenres(p.genre).some(g => selectedGenres.includes(g))) return false;
    // 80차 후속: [버그 수정] 체험형은 난이도 개념이 없어(activityLevel을 씀) 표시엔 이미
    // 안 보이게 되어있지만, 원본 theme.difficulty 필드엔 emptyTheme() 기본값("normal")이
    // 그대로 남아있어서 이 필터가 그걸 그대로 비교해 엉뚱하게 걸리거나 빠지고 있었음
    // (fork 2건 독립 발견) — 난이도 필터가 켜져 있으면 체험형은 형식 무관하게 항상 제외.
    if (selectedDifficulties.length && ((p.bookingFormat||'room')==='show' || !selectedDifficulties.includes(p.difficulty))) return false;
    if (selectedFormat && (p.bookingFormat||'room') !== selectedFormat) return false;
    if (onlyFav && !favMap[p.id]) return false;
    if (peopleFilter) {
      const num=parseInt(peopleFilter), isPlus=peopleFilter.includes('+');
      if (isPlus) { if (getPMax(p)<num) return false; }
      else { if (getPMin(p)>num||getPMax(p)<num) return false; }
    }
    return true;
  }).sort((a,b) => {
    switch(sortBy) {
      case 'review':    return (b.reviewCount||0)-(a.reviewCount||0);
      case 'newest':    return (b.createdAt||'').localeCompare(a.createdAt||'');
      case 'price_asc': return getMinPrice(a)-getMinPrice(b);
      default:          return (b.rating||0)-(a.rating||0);
    }
  }), [products, searchKeyword, selectedCity, selectedGenres, selectedDifficulties, selectedFormat, onlyFav, favMap, peopleFilter, sortBy]);

  const activeFilterCount = selectedGenres.length + selectedDifficulties.length +
    (selectedCity?1:0)+(selectedFormat?1:0)+(onlyFav?1:0)+(peopleFilter?1:0)+(sortBy!=='rating'?1:0);

  // 74차: PICK을 예약 탭의 기본 화면 상단에 노출 — 검색/필터가 하나도 안 걸린 "기본
  // 상태"에서만 보여주고, 검색·필터를 걸면(구체적 의도가 생기면) 원래처럼 결과 목록만
  // 보여줌. 아래 전체 테마 목록은 그대로 이어서 노출(PICK 아닌 매장도 계속 보이게 하기
  // 위함 — PICK 전용으로 완전히 가리면 비BOOST 매장이 예약 탭에서 안 보이게 됨)
  const pickedProducts = useMemo(() =>
    products.filter(p => pickProductIds.has(p.id)),
    [products, pickProductIds]
  );
  const showPickSection = !searchKeyword && activeFilterCount === 0 && pickedProducts.length > 0;
  const suggestions = useMemo(() => inputValue.trim()
    ? products.filter(p => normalizeProduct(p).name?.toLowerCase().includes(inputValue.toLowerCase()) || p.genre?.toLowerCase().includes(inputValue.toLowerCase())).slice(0,5) : [],
    [inputValue, products]
  );
  const handleSearch = kw => {
    const t=kw.trim(); setSearchKeyword(t); setInputValue(t); setShowSuggestions(false);
    if (!t) return;
    setRecentSearches(prev=>[t,...prev.filter(s=>s!==t)].slice(0,5));
  };
  const toggleGenre      = g => setSelectedGenres(prev=>prev.includes(g)?prev.filter(x=>x!==g):[...prev,g]);
  const toggleDifficulty = d => setSelectedDifficulties(prev=>prev.includes(d)?prev.filter(x=>x!==d):[...prev,d]);
  const resetFilters = () => { setSelectedGenres([]); setSelectedDifficulties([]); setSelectedCity(null); setSelectedFormat(null); setOnlyFav(false); setPeopleFilter(null); setSortBy('rating'); };
  // 74차: 예약 탭 필터가 다른 탭으로 이동해도 안 풀리던 문제 — Booking은 GeneralTabNavigator의
  // 최상위 Tab.Screen이라 이 navigation은 곧 그 Tab.Navigator 자체. 'state' 이벤트를
  // 이 navigation에 직접 구독하면 "이 Tab.Navigator 안에서 탭이 바뀔 때"만 감지되고,
  // ThemeDetail처럼 AppStack(상위 네비게이터)에 화면이 쌓일 때는(별개 네비게이터라) 반응하지
  // 않는다 — navigation.addListener('blur', ...)를 썼다면 테마 상세를 보고 돌아올 때도
  // 매번 필터가 초기화되는 부작용이 있었을 것.
  useEffect(() => {
    return navigation.addListener('state', (e) => {
      const tabState = e.data.state;
      const activeName = tabState?.routes?.[tabState.index]?.name;
      if (activeName && activeName !== 'Booking') resetFilters();
    });
  }, [navigation]);

  return (
    <View style={s.container}>
      <AppHeader />
      {isStoreAdmin && (
        <View style={{ backgroundColor:GOLD+'14', paddingHorizontal:16, paddingVertical:8, borderBottomWidth:1, borderBottomColor:GOLD+'33' }}>
          <IconLabel Icon={MenuStoreIcon} size={13} color={GOLD} textStyle={{ color:GOLD, fontSize:12, fontWeight:'600' }} style={{ justifyContent:'center' }}>매장관리자 모드</IconLabel>
        </View>
      )}

      {/* 49차: 검색바 + 필터 버튼을 하나의 고정 행으로 */}
      <View style={s.searchRow}>
        <View style={s.searchBar}>
          <Ionicons name="search" size={16} color={TEXT_MUTED} style={{ paddingHorizontal: 10 }} />
          <TextInput
            style={s.searchInput} placeholder="테마명, 지역, 장르로 검색" placeholderTextColor={TEXT_MUTED}
            value={inputValue}
            onChangeText={v => { setInputValue(v); setShowSuggestions(true); }}
            onSubmitEditing={() => handleSearch(inputValue)}
            returnKeyType="search"
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
          />
          {inputValue ? (
            <TouchableOpacity onPress={() => { setInputValue(''); setSearchKeyword(''); }} hitSlop={{top:8,bottom:8,left:8,right:8}}
              accessibilityLabel="검색어 지우기">
              <Ionicons name="close-circle" size={16} color={TEXT_MUTED} style={{ paddingHorizontal: 8 }} />
            </TouchableOpacity>
          ) : null}
          <TouchableOpacity style={s.searchSubmit} onPress={() => handleSearch(inputValue)}>
            <Text style={s.searchSubmitText}>검색</Text>
          </TouchableOpacity>
        </View>

        {/* 49차: 필터 버튼 — width/height 하드코딩, flexShrink:0, overflow:hidden */}
        <TouchableOpacity style={s.filterBtn} onPress={() => setShowFilter(true)} accessibilityLabel="필터">
          <Ionicons name="options-outline" size={20} color={GOLD} />
          {activeFilterCount > 0 && (
            <View style={s.filterBadge}>
              <Text style={s.filterBadgeText}>{activeFilterCount}</Text>
            </View>
          )}
        </TouchableOpacity>
      </View>

      {/* 자동완성 */}
      {showSuggestions && (suggestions.length>0||recentSearches.length>0) && (
        <View style={s.dropdown}>
          {suggestions.length>0 && <><IconLabel Icon={SearchIcon} size={11} color={TEXT_MUTED} gap={5}
              style={{ paddingHorizontal:14, paddingTop:10, paddingBottom:4 }}
              textStyle={{ color:TEXT_MUTED, fontSize:10, fontWeight:'700', letterSpacing:0.8 }}>연관 검색</IconLabel>
            {suggestions.map(p => { const n=normalizeProduct(p); return (
              <TouchableOpacity key={p.id} style={s.dropdownItem} onPress={()=>handleSearch(n.name)}>
                <Text style={s.dropdownTitle}>{n.name}</Text>
                <Text style={s.dropdownSub}>{p.genre} · {p.city}</Text>
              </TouchableOpacity>); })}</>}
          {recentSearches.length>0 && !inputValue.trim() && <><IconLabel Icon={MenuPointsIcon} size={11} color={TEXT_MUTED} gap={5}
              style={{ paddingHorizontal:14, paddingTop:10, paddingBottom:4 }}
              textStyle={{ color:TEXT_MUTED, fontSize:10, fontWeight:'700', letterSpacing:0.8 }}>최근 검색어</IconLabel>
            {recentSearches.map(kw => (
              <TouchableOpacity key={kw} style={s.dropdownItem} onPress={()=>handleSearch(kw)}>
                <Text style={s.dropdownTitle}>{kw}</Text>
                <TouchableOpacity onPress={()=>setRecentSearches(prev=>prev.filter(x=>x!==kw))} accessibilityLabel="최근 검색어 삭제"><CancelIcon size={13} color={s.dropdownSub.color || TEXT_MUTED} /></TouchableOpacity>
              </TouchableOpacity>))}</>}
        </View>
      )}

      {searchKeyword ? (
        <View style={s.activeSearch}>
          <IconLabel Icon={SearchIcon} size={12} color={GOLD} textStyle={s.activeSearchText}>"{searchKeyword}" 검색 중</IconLabel>
          <TouchableOpacity onPress={()=>{ setSearchKeyword(''); setInputValue(''); }}>
            <IconLabel Icon={CancelIcon} size={11} color={s.activeSearchClear.color || TEXT_MUTED} textStyle={s.activeSearchClear}>초기화</IconLabel>
          </TouchableOpacity>
        </View>
      ) : null}

      {/* 49차: ActiveFilterTags — searchRow와 완전 분리, 별도 행 */}
      <ActiveFilterTags
        genres={selectedGenres} city={selectedCity} selectedFormat={selectedFormat} onlyFav={onlyFav}
        difficulties={selectedDifficulties} peopleFilter={peopleFilter}
        onRemoveGenre={toggleGenre} onRemoveCity={()=>setSelectedCity(null)}
        onRemoveFormat={()=>setSelectedFormat(null)} onRemoveFav={()=>setOnlyFav(false)}
        onRemoveDifficulty={toggleDifficulty} onRemovePeople={()=>setPeopleFilter(null)}
      />

      <View style={s.resultHeader}>
        <Text style={s.resultTitle}>테마 목록</Text>
        <Text style={s.resultCount}>({loading?'...':filtered.length}개)</Text>
      </View>

      {loading ? <LoadingOverlay inline /> : (
        <FlatList
          data={filtered} keyExtractor={item=>String(item.id)}
          contentContainerStyle={{ paddingBottom:24, paddingTop:4, paddingHorizontal:16 }}
          refreshControl={<RefreshControl refreshing={refreshing} onRefresh={()=>{ setRefreshing(true); load(); }} tintColor={GOLD} />}
          renderItem={({ item }) => (
            <ProductCard item={item} isFav={!!favMap[item.id]}
              onFavToggle={id=>{ if (!isLoggedIn){ navigation.navigate('Login'); return; } toggleFav(id); }}
              isSoldOut={false} searchKeyword={searchKeyword} isPick={pickProductIds.has(item.id)}
              onPress={p=>navigation.navigate('ThemeDetail',{ product:p })} />
          )}
          ListHeaderComponent={showPickSection ? (
            <View style={s.pickSection}>
              {/* 80차 계속: 지역별 인기 테마 랭킹 화면(RegionalRankingScreen) 진입로 추가 —
                  기존엔 홈 탭 "전체보기" 텍스트 링크 하나뿐이라 접근성이 낮았음. 예약 탭
                  기본 화면(검색/필터 없는 상태)은 사용자가 가장 자주 보는 지점이라 여기에
                  배너로 노출해 발견 경로를 하나 더 둠. */}
              <TouchableOpacity style={s.rankingBanner} activeOpacity={0.85}
                onPress={() => navigation.navigate('RegionalRanking')}>
                <TrophyIcon size={18} color={GOLD} />
                <Text style={s.rankingBannerText}>우리 동네 인기 테마 랭킹 보기</Text>
                <Text style={s.rankingBannerArrow}>→</Text>
              </TouchableOpacity>
              <View style={s.pickSectionTitleRow}>
                <SpotlightStarIcon size={17} color="#EFD292" />
                <Text style={s.pickSectionTitle}>지금 주목할 PICK</Text>
              </View>
              {pickedProducts.map(item => (
                <ProductCard key={item.id} item={item} isFav={!!favMap[item.id]}
                  onFavToggle={id=>{ if (!isLoggedIn){ navigation.navigate('Login'); return; } toggleFav(id); }}
                  isSoldOut={false} isPick
                  onPress={p=>navigation.navigate('ThemeDetail',{ product:p })} />
              ))}
              <View style={s.pickSectionDivider} />
              <Text style={s.allThemesLabel}>전체 테마</Text>
            </View>
          ) : null}
          ListEmptyComponent={
            (searchKeyword||activeFilterCount>0) ? (
              <View style={{ alignItems:'center', marginTop:60, gap:12 }}>
                <SearchIcon size={40} color={TEXT_MUTED} />
                <Text style={{ color:TEXT_MUTED, fontSize:14 }}>조건에 맞는 테마가 없습니다.</Text>
                <TouchableOpacity onPress={()=>{ setSearchKeyword(''); setInputValue(''); resetFilters(); }}>
                  <Text style={{ color:GOLD, fontSize:13, fontWeight:'700', borderWidth:1, borderColor:GOLD, borderRadius:20, paddingHorizontal:16, paddingVertical:6 }}>검색 초기화</Text>
                </TouchableOpacity>
              </View>
            ) : (
              // 80차 계속: 필터 없이도 결과가 0건 = 앱에 등록된 매장이 아예 없는 진짜
              // 빈 상태(오픈 초기 시나리오) — HomeScreen.js의 동일 안내와 톤을 맞춤,
              // 모집 게시판으로 명시적으로 유도.
              <View style={{ alignItems:'center', marginTop:60, gap:8, paddingHorizontal:32 }}>
                <EmptyStoresIcon size={64} />
                <Text style={{ color:TEXT, fontSize:16, fontWeight:'800', marginTop:6 }}>새로운 매장을 준비하고 있어요</Text>
                <Text style={{ color:TEXT_MUTED, fontSize:13, textAlign:'center', lineHeight:20 }}>
                  매장이 열리기 전에도{'\n'}모집 게시판에서 같이 갈 사람을 먼저 구해보세요
                </Text>
                <GradientButton label="모집 게시판 보러가기 →" onPress={() => navigation.navigate('Recruit')} style={{ marginTop:10, paddingHorizontal:20 }} />
              </View>
            )
          }
          ListFooterComponent={
            // 80차 계속: 매장 제휴 문의 — 매장이 몇 곳이든(0곳인 지금도, 나중에 생겨도)
            // 계속 유효한 CTA라 결과 유무와 무관하게 목록 맨 아래에 상시 노출. HomeScreen.js
            // 푸터의 "매장 제휴 문의"와 동일한 창구(WriteInquiry, targetType:'app') 재사용.
            <TouchableOpacity
              style={{ alignItems:'center', paddingVertical:20 }}
              onPress={() => {
                if (!isLoggedIn) {
                  showAlert('로그인 필요', '제휴 문의는 로그인 후 이용 가능합니다.', [
                    { text: '취소', style: 'cancel' },
                    { text: '로그인하기', onPress: () => navigation.navigate('Login') },
                  ]);
                  return;
                }
                navigation.navigate('WriteInquiry', { targetType: 'app' });
              }}>
              <Text style={{ color:TEXT_MUTED, fontSize:12 }}>매장 사장님이신가요? <Text style={{ color:GOLD, fontWeight:'700' }}>제휴 문의하기</Text></Text>
            </TouchableOpacity>
          }
        />
      )}

      <FilterBottomSheet
        visible={showFilter} cities={cities}
        selectedGenres={selectedGenres} selectedDifficulties={selectedDifficulties}
        selectedCity={selectedCity} peopleFilter={peopleFilter}
        selectedFormat={selectedFormat} onlyFav={onlyFav} sortBy={sortBy} loggedIn={isLoggedIn}
        onToggleGenre={toggleGenre} onToggleDifficulty={toggleDifficulty}
        onSelectCity={setSelectedCity} onSelectPeople={setPeopleFilter}
        onSelectFormat={setSelectedFormat} onToggleFav={setOnlyFav}
        onSelectSort={setSortBy} onReset={resetFilters} onClose={()=>setShowFilter(false)}
      />
    </View>
  );
}

const s = StyleSheet.create({
  container:   { flex:1, backgroundColor:BG },
  // 49차: searchRow — 고정 높이, overflow hidden으로 내부 변화 차단
  searchRow:   { flexDirection:'row', alignItems:'center', marginHorizontal:16, marginTop:12, marginBottom:8, gap:8 },
  searchBar:   { flex:1, height:46, flexDirection:'row', alignItems:'center', backgroundColor:SURFACE, borderRadius:RADIUS.md, borderWidth:1, borderColor:BORDER, overflow:'hidden' },
  // 78차 43차: 웹에서 포커스 시 브라우저 기본 파란 아웃라인이 좌우로 번쩍이듯 보이던 것 —
  // 네이티브에서는 모르는 속성이라 그냥 무시되니 안전하게 웹에서만 제거
  searchInput: { flex:1, height:46, color:TEXT, fontSize:13, fontFamily:FONTS.body, paddingVertical:0, outlineStyle:'none' },
  searchSubmit:    { height:46, backgroundColor:GOLD, paddingHorizontal:14, justifyContent:'center', alignItems:'center' },
  searchSubmitText:{ color:ON_GOLD, fontSize:12, fontWeight:'800' },
  // 49차: 필터 버튼 — 완전 고정, 어떤 상태도 크기 변화 없음
  filterBtn:       { width:46, height:46, borderRadius:RADIUS.md, backgroundColor:SURFACE, borderWidth:1, borderColor:BORDER, justifyContent:'center', alignItems:'center', flexShrink:0, overflow:'hidden' },
  filterBadge:     { position:'absolute', top:4, right:4, backgroundColor:GOLD, borderRadius:8, minWidth:16, height:16, alignItems:'center', justifyContent:'center', paddingHorizontal:3 },
  filterBadgeText: { color:ON_GOLD, fontSize:9, fontWeight:'900' },
  dropdown:      { marginHorizontal:16, backgroundColor:SURFACE, borderRadius:12, borderWidth:1, borderColor:BORDER, marginBottom:8, overflow:'hidden' },
  dropdownLabel: { color:TEXT_MUTED, fontSize:10, fontWeight:'700', paddingHorizontal:14, paddingTop:10, paddingBottom:4, letterSpacing:0.8 },
  dropdownItem:  { flexDirection:'row', justifyContent:'space-between', alignItems:'center', paddingHorizontal:14, paddingVertical:10, borderTopWidth:1, borderTopColor:'rgba(255,255,255,0.04)' },
  dropdownTitle: { color:TEXT, fontSize:13 },
  dropdownSub:   { color:TEXT_MUTED, fontSize:11 },
  activeSearch:      { flexDirection:'row', alignItems:'center', justifyContent:'space-between', paddingHorizontal:16, paddingBottom:6 },
  activeSearchText:  { color:GOLD, fontSize:12 },
  activeSearchClear: { color:TEXT_MUTED, fontSize:12, borderWidth:1, borderColor:BORDER, borderRadius:12, paddingHorizontal:10, paddingVertical:3 },
  resultHeader:  { flexDirection:'row', alignItems:'center', paddingHorizontal:16, paddingBottom:8 },
  resultTitle:   { color:GOLD, fontSize:14, fontWeight:'800' },
  resultCount:   { color:TEXT_MUTED, fontSize:12, marginLeft:4 },
  // 74차: 예약 탭 기본 화면 PICK 섹션
  pickSection:      { marginBottom: 4 },
  // 80차 계속: 지역별 인기 테마 랭킹 진입 배너
  rankingBanner: { flexDirection:'row', alignItems:'center', gap:8, backgroundColor: GOLD+'14', borderWidth:1, borderColor: GOLD+'40', borderRadius:14, paddingVertical:12, paddingHorizontal:14, marginBottom:16 },
  rankingBannerText: { flex:1, color: COLORS.text, fontSize:13, fontWeight:'700' },
  rankingBannerArrow: { color: GOLD, fontSize:15, fontWeight:'700' },
  // 78차 21차: 340x60 원본 크기 그대로 쓰면 배너 안 반짝임/별 장식이 텍스트와
  // 겹쳐 보였음(스크린샷으로 재신고) — 가로세로 비율 유지한 채 절반 크기로 축소하고
  // paddingLeft를 그만큼 좁혀 텍스트가 별 장식 밖에서 시작하도록 여유를 둠.
  // 78차 23차: 절대위치 장식 배너(PickBanner, translate+scale 트랜스폼 다중 사용)가
  // react-native-svg에서 두 차례 다 텍스트와 겹쳐 보이는 버그를 냈음 — 원인이 정확히
  // 트랜스폼 문자열 파싱 쪽으로 의심되나 완전히 확진은 못 해, 아예 절대위치 오버레이
  // 방식 자체를 버리고 다른 섹션 제목들과 동일한 평범한 아이콘+텍스트 행으로 단순화.
  pickSectionTitleRow: { flexDirection:'row', alignItems:'center', gap:6, marginBottom:10 },
  pickSectionTitle: { color:'#EFD292', fontSize:15, fontWeight:'900' },
  pickSectionDivider: { height:1, backgroundColor:BORDER, marginVertical:16 },
  allThemesLabel:   { color:TEXT_MUTED, fontSize:12, fontWeight:'700', letterSpacing:0.5, marginBottom:10 },
});